import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaymentPayload } from '../models/payment_payload';
import { GraphQLService } from './graphql.service';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';

import paymentPayloadQuery from 'src/app/graphql/queries/payment_payload.query.graphql'

@Injectable()
export class PaymentPayloadService extends GraphQLService<PaymentPayload> {

  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar)
  }

  fetchPayload(provider: string, builderhash: string): Observable<PaymentPayload> {
    return this.push(paymentPayloadQuery, {provider, builderhash})
  }

}
